import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const edsCompAssignmentSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getEDSCompAssignments: builder.query({
            query: () => {
                return {
                    url: constants.GET_EDS_COMP_ASSIGNMENTS,
                };
            },
            providesTags: ['assignments'],
        }),
        createEDSCompAssignment: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_EDS_COMP_ASSIGNMENTS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['assignments'],
        }),
        deleteEDSCompAssignment: builder.mutation({
            query: (arg : any) => ({
                url: constants.DELETE_EDS_COMP_ASSIGNMENTS,
                method: 'PUT',
                body: arg.scManagementAssignIds,
                params: {employeeNumber: arg.employeeNumber},
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['assignments'],
        }),
    }),
});

export const { useGetEDSCompAssignmentsQuery,useCreateEDSCompAssignmentMutation,useDeleteEDSCompAssignmentMutation } = edsCompAssignmentSlice;
